var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCulture(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 42,
    viewBox: "0 0 40 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 42V20H4V24H8L13.95 4.25V0H17.95V4H22V0H26V4L32 24H36V20H40V42H22V32H18V42H0V42M13.4 20H26.6L25.4 16H14.6L13.4 20V20M15.8 12H24.2L23 8H17L15.8 12V12M4 38H14V28H26V38H36V28H29L27.8 24H12.2L11 28H4V38V38M20 23V23V23V23V23V23V23V23V23V23V23V23V23V23V23V23V23V23V23V23V23V23V23V23V23V23V23V23V23V23",
    fill: "#FDC82A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCulture);
export default __webpack_public_path__ + "static/media/culture.ea0e022ff8a7b4d22c776af25a37de4f.svg";
export { ForwardRef as ReactComponent };